import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
export const VideoInner = styled.div.withConfig({
  displayName: "partials__VideoInner",
  componentId: "sc-2veduc-0"
})(["width:100%;margin:0 auto;", ";"], minMediaQueries.phablet`
    max-width: ${grid(6)}px;
  `);